import AssociatedPress from '@/models/AssociatedPress'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    articleDetails: {}
  },

  mutations: {
    setAPList (state, articles) {
      each(articles, article => {
        const exist = find(state.list, { uri: article.uri })
        if (!exist) {
          state.list.push(new AssociatedPress(article))
        }
      })
    },

    setArticleDetails (state, payload) {
      state.articleDetails = payload
    },

    setListMeta (state, payload) {
      state.listMeta.current_page = payload.current_page
      state.listMeta.total_items = payload.total_items
      state.listMeta.page_size = payload.page_size
      state.listMeta.last_page =  Math.ceil(payload.total_items / payload.page_size)
      state.listMeta.next_page_url =  payload.next_page
    }
  },

  actions: {
    async getAPArticles ({ commit }, params) {
      await Api.get(`admin/ap-media/searches`, { params: params })
        .then(response => {
          commit('setAPList', response.data.data)
          commit('setListMeta', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getAPArticleDetails ({ commit }, params) {
      await Api.get(`admin/ap-media/feeds/` + params.itemId)
        .then(response => {
          commit('setArticleDetails', response.data.data)
        })
        .catch(error => {
          console.log(error)
        })
    },

    async loadMoreAPArticles ({commit}, params) {
      await Api.get(`admin/ap-media/searches/next-page`, { params: params })
      .then(response => {
        commit('setAPList', response.data.data)
        commit('setListMeta', response.data)
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
